<template>
  <div id="intro">
    <span>{{ timestamp }}</span>
    <div class="d-flex">
      <p>цаг</p>
      <p>мин</p>
      <p>сек</p>
    </div>
  </div>
</template>

<script>
export default {
  el: "#intro",
  props: ["number"],
  data() {
    return {
      timestamp: "",
      order: "",
    };
  },
  created() {
    setInterval(this.getNow, 1000);
    let start = this.getNow();

    if (!localStorage.getItem("start")) {
      var new_time = new Date();
      localStorage.setItem("start", new_time.getTime(start));
    }
  },
  methods: {
    getNow: function () {
      const today = new Date();
      const time =
        (today.getHours() < 10 ? "0" : "") +
        today.getHours() +
        ":" +
        ((today.getMinutes() < 10 ? "0" : "") + today.getMinutes()) +
        ":" +
        (today.getSeconds() < 10 ? "0" : "") +
        today.getSeconds();
      const dateTime = time;
      this.timestamp = dateTime;
      return this.timestamp;
    },
  },
};
</script>
<style scoped>
* {
  font-family: "Roboto", sans-serif;
}
.d-flex {
  font-size: 0.5em;
  width: 63%;
  color: #6d6d6d;
  display: flex;
  justify-content: space-around;
  margin: 0 auto 0 auto;
  margin-top: -10px;
}
span {
  margin-bottom: -10px;
}
</style>
